module.exports = __webpack_public_path__ + "static/media/AmeliaCarlie_Resume.cdfe7db3.pdf";